export const teaser = (text: string, maxLength: number = 200) => {
  if (text.length <= maxLength) {
    return text
  }
  return text.substr(0, maxLength)
}
